<app-header></app-header>


<!--====== PAGE TITLE PART START ======-->
<div class="banner-active">
    <div class="single-banner bg_cover" *ngFor="let slide of slideData;let index=i" [ngStyle]="{'background-image': 'url('+slide.img+')', 'background-repeat': 'no-repeat'}">
        <div class="banner-overlay">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="banner-content text-center">
                            <h1 data-animation="fadeInLeft" data-delay="0.9s" class="title c-title" [innerHTML]="slide.title"></h1>
                            <span data-animation="fadeInLeft" data-delay="0.5s" class="c-sub-title">{{slide?.subTitle}}</span>
                            <!-- <p data-animation="fadeInLeft" data-delay="1.3s">{{slide?.description}} </p> -->
                            <div data-animation="fadeInLeft" data-delay="1.3s">
                                <!-- <div class="assistance"> -->
                                <span class="assurance">
                  {{slide.type}}
                </span>
                                <div class="barre-bottom"></div>
                                <img class="assu-img" [src]="slide.imgIcon" alt="">

                                <!-- </div> -->
                            </div>
                            <span data-animation="fadeInUp" data-delay="1.6s" class="main-btn-title" *ngIf="title!=''">{{title}}</span>
                            <a class="main-btn" data-animation="fadeInUp" data-delay="1.6s" (click)="souscrireAutomobile()">Obtenir un devis</a>
                            <!-- <button type="button" class="btn btn-primary" (click)="souscrireAutomobile()">Connexion</button> -->
                        </div>
                        <!-- banner content -->
                    </div>
                </div>
                <!-- row -->
            </div>
            <!-- container -->
        </div>
    </div>
</div>


<!--====== NOUVELLES ÉTAPES ======-->
<div class="new-steps-container" *ngIf="currentStep < 2">
    
    <!-- Étape 0: Accueil -->
    <div class="welcome-step" *ngIf="currentStep === 0">
        <div class="container">
            <div class="welcome-content">
                <h1>Bonjour ! Je suis Marilyne</h1>
                <h2>Je suis là pour vous aider</h2>
                <p class="welcome-description">
                    Obtenez votre devis d'assurance véhicule en quelques minutes seulement.
                    Je vais vous guider étape par étape pour trouver la meilleure protection.
                </p>
                <button class="cta-button" (click)="nextStep()">
                    C'est parti !!
                </button>
            </div>
        </div>
    </div>

    <!-- Étape 1: Type d'assurance -->
    <div class="step-container" *ngIf="currentStep === 1">
        <div class="container">
            <div class="step-header">
                <h2>Vous souhaitez assurer :</h2>
            </div>
            
            <div class="options-grid">
                <div class="option-card" 
                     [class.selected]="individuel"
                     (click)="individuelvoid()">
                    <div class="option-icon">
                        <img src="assets/images/assurance-voiture.png" alt="Véhicule individuel">
                    </div>
                    <h3>Assurer un véhicule / une moto</h3>
                    <p>Pour un véhicule personnel ou professionnel</p>
                    <div class="check-icon" *ngIf="individuel">✓</div>
                </div>
                
                <div class="option-card" 
                     [class.selected]="flotte"
                     (click)="flottevoid()">
                    <div class="option-icon">
                        <img src="assets/images/embouteillage.png" alt="Flotte">
                    </div>
                    <h3>Assurer une flotte</h3>
                    <p>Pour plusieurs véhicules d'entreprise</p>
                    <div class="check-icon" *ngIf="flotte">✓</div>
                </div>
            </div>

            <div class="step-navigation" *ngIf="individuel || flotte">
                <!-- <button class="btn-back" (click)="previousStep()">
                    <img src="assets/images/icon-bouton-precedent.svg" alt="Précédent">
                    Retour
                </button> -->
                <button class="btn-continue" (click)="nextStep()">
                    Continuer
                    <img src="assets/images/icon-bouton-suivant.svg" alt="Suivant">
                </button>
            </div>
        </div>
    </div>
</div>


<!-- Formulaire d'assurance automobile modernisé et conversationnel -->
<div class="desc container-fluid d-flex justify-content-center align-items-center" id="contact" #contact style="margin-bottom: 50px;" *ngIf="currentStep >= 2 && login">
    <!-- *ngIf="login" -->
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 droite" style="margin-top: 10px;">
        <form [formGroup]="simulationVehiculeForm" class="auto">
            <aw-wizard class="stepper-container bg-whtie pb-5" #wizard [navBarLocation]="'top'" [navBarLayout]="'large-empty'" [disableNavigationBar]="false">
              <aw-wizard-step [navigationSymbol]="{ symbol: '1' }" stepTitle="Assuré">
                <h4 class="section-title">Informations de l'assuré</h4>
                    <div class="form-container formulaire" formGroupName="assure" style="max-width: 660px !important;">
                        <div class="row no-margin">
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" style="flex: 0 0 40% !important;">
                                <div class="semi">
                                    <input type="text" name='prenom' formControlName="nom" placeholder="Nom *" noAutocomplete>
                                    <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                                    <img src="assets/images/nom.svg" alt="">
                                    <!-- <span  class="text-red-plus">*</span> -->
                                    </span>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" style="flex: 0 0 40% !important;">
                                <div class="semi">
                                    <input type="text" name='prenom' formControlName="prenom" placeholder="Prénom *" noAutocomplete>
                                    <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                                    <img src="assets/images/nom.svg" alt="">
                                    <!-- <span  class="text-red-plus">*</span> -->
                                    </span>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" style="flex: 0 0 40% !important;">
                                <div class="semi">
                                    <input type="text" [maxDate]="maxDateNaissance" formControlName="dateNaissance" #dateItem="bsDatepicker" [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name="date" placeholder="Date de naissance *">
                                    <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                                    <img src="assets/images/icon-date.svg" alt="">
                                    <!-- <span class="text-red-plus">*</span> -->
                                    </span>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" style="flex: 0 0 40% !important;">
                                <div class="semi">
                                    <input type="text" formControlName="adresse" name='adresse' placeholder="Adresse" noAutocomplete>
                                    <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                                    <img src="assets/images/icon-adresse.svg" alt="">
                                    <!-- <span  class="text-red-plus">*</span> -->
                                    </span>
                                </div>
                            </div>

                             <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" style="flex: 0 0 40% !important;">
                                <div class="semi">
                                    <input type="email" name="email" formControlName="email" placeholder="Email" noAutocomplete>
                                    <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                                     <img src="assets/images/icon-email.svg" alt="">
                                     <!-- <span  class="text-red-plus">*</span> -->
                                    </span>
                                </div>
                                <div *ngIf="simulationVehiculeForm.get('assure').get('email').errors">
                                    <div
                                        *ngIf="simulationVehiculeForm.get('assure').get('email').errors.required && (simulationVehiculeForm.get('assure').get('email').dirty || simulationVehiculeForm.get('assure').get('email').touched)">
                                        <div class="text-red">
                                        Ce champs est obligatoire
                                        </div>
                                    </div>
                                    <div *ngIf="simulationVehiculeForm.get('assure').get('email').errors.pattern">
                                        <div class="text-red">
                                        Email est invalide
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- personne moral -->
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" style="flex: 0 0 40% !important;">
                                <div class="semi">
                                    <!-- (hasError)="hasError($event,'numeroTelephone','assure')" -->
                                    <input
                                      type="text"
                                      formControlName="numeroTelephone"
                                      numberOnly class="input-tel" name='numeroTelephone'
                                      placeholder="Téléphone *" ng2TelInput [ng2TelInputOptions]="{initialCountry: currentFiliale?.code}"
                                      clearInput (focus)="isFocus=true" (blur)="isFocus=false"
                                      (ng2TelOutput)="getNumber($event,'numeroTelephone','assure')"
                                      (intlTelInputObject)="telInputObject($event)"
                                      (countryChange)="onCountryChange($event)"
                                      (blur)="isFocus=false;autoSave()" noAutocomplete
                                      />
                                </div>
                                <div *ngIf="simulationVehiculeForm.get('assure').get('numeroTelephone').errors">
                                    <div
                                        *ngIf="simulationVehiculeForm.get('assure').get('numeroTelephone').errors.required && (simulationVehiculeForm.get('assure').get('numeroTelephone').dirty || simulationVehiculeForm.get('assure').get('numeroTelephone').touched)">
                                        <div class="text-red">
                                        Ce champs est obligatoire
                                        </div>
                                    </div>
                                </div>
                            </div>
                           

                        </div>
                    </div>
                <div class="step-navigation">
                    <button class="btn-back" awPreviousStep (click)="retour()">
                        <img src="assets/images/icon-bouton-precedent.svg" alt="Précédent">
                        Retour
                    </button>
                    <button class="btn-continue" awNextStep>
                        Continuer
                        <img src="assets/images/icon-bouton-suivant.svg" alt="Suivant">
                    </button>
                </div>
                </aw-wizard-step>
                <aw-wizard-step [navigationSymbol]="{ symbol: '2' }" stepTitle="Véhicule & Garanties"> 
                <div class="row">
                    <div class="col-6 col-lg-6 col-md-6 col-sm-12 mb-3">  
                         <div class="form-container formulaire" style="padding: 20px; border-radius: 8px; border: 1px solid #dee2e6;">
                        <h4 class="section-title">Informations du véhicule</h4>
                        <div class="row">
                            <div class="input-box" style="width: 625px !important; margin-left: 16px !important;">
                                <ng-select formControlName="typeVehicule" (change)="selectVehiculeCategories($event)" clearAllText="Effacer tout" notFoundText="Aucun élément trouvé" [dropdownPosition]="'bottom'" [items]="vehiculeCategories" bindLabel="libelle" bindValue="id" class="custom"
                                    placeholder="Categorie" typeToSearchText="Taper pour rechercher" #vehicule>
                                </ng-select>
                                <span class="img-form2" placement="top" triggers="mouseenter:mouseleave">
                                <img src="assets/images/icon-marque-auto.svg" alt="">
                                <!-- <span  class="text-red-plus">*</span> -->
                                </span>
                            </div>
                            
                            <div class="col-lg-6 col-md-12 col-xs-12 col-sm-12" *ngIf="categorieVehicule && transportP">
                                <div class="semi">
                                    <ng-select formControlName="typeVehiculePublic" clearAllText="Effacer tout" notFoundText="Aucun élément trouvé" [dropdownPosition]="'bottom'" [items]="transportPublicList" bindLabel="libelle" bindValue="id" class="custom" placeholder="Type de véhicule"
                                        typeToSearchText="Taper pour rechercher">
                                    </ng-select>
                                    <span class="img-form2" placement="top" triggers="mouseenter:mouseleave">
                                <img src="assets/images/icon-marque-auto.svg" alt="">
                                <!-- <span  class="text-red-plus">*</span> -->
                                    </span>
                                </div>
                            </div>
                            
                            <div class="col-lg-6 col-md-12 col-xs-12 col-sm-12" *ngIf="categorieVehicule && camion">
                                <div class="semi">
                                    <input type="number" formControlName="poidsVehicule" numberOnly min="0" name="" placeholder="Poids du véhicule">
                                    <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                                    <img src="assets/images/icon-marque-auto.svg" alt="">
                                    <!-- <span  class="text-red-plus">*</span> -->
                                    </span>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12 col-xs-12 col-sm-12" *ngIf="categorieVehicule && moto">
                                <div class="semi">
                                    <input type="number" formControlName="cylindree" numberOnly min="0" name="" placeholder="Cylindrée">
                                    <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                                    <img src="assets/images/icon-marque-auto.svg" alt="">
                                    <!-- <span  class="text-red-plus">*</span> -->
                                    </span>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-12 col-xs-12 col-sm-12" *ngIf="categorieVehicule">
                                <div class="semi">
                                    <ng-select formControlName="typeMoteur" clearAllText="Effacer tout" notFoundText="Aucun élément trouvé" [dropdownPosition]="'bottom'" [items]="carburantList" bindLabel="name" bindValue="value" class="custom" placeholder="Type de Carburant" typeToSearchText="Taper pour rechercher">
                                    </ng-select>
                                    <span class="img-form2" placement="top" triggers="mouseenter:mouseleave">
                                <img src="assets/images/icon-types-de-carburant.svg" alt="">
                              
                                    </span>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" *ngIf="(subVehiculeCategories?.length > 0 ||  categorieVehicule) && !moto">
                                <div class="semi">
                                    <input type="number" formControlName="nombrePlace" numberOnly min="0" name="" placeholder="Nombre de places">
                                    <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                                    <img src="assets/images/icon-marque-auto.svg" alt="">
                                    <!-- <span  class="text-red-plus">*</span> -->
                                    </span>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" *ngIf="categorieVehicule ">
                                <div class="semi">
                                    <input type="number" formControlName="puissance" numberOnly min="0" name="" placeholder="Puissance">
                                    <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                                    <img src="assets/images/icon-puissance-auto.svg" alt="">
                                    <!-- <span  class="text-red-plus">*</span> -->
                                    </span>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" *ngIf="subVehiculeCategories?.length > 0 ||  categorieVehicule ">
                                <div class="semi">
                                    <input type="text" name='prenom' formControlName="immatriculation" placeholder="Immatriculation du véhicule">
                                    <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                                    <img src="assets/images/icon-marque-auto.svg" alt="">
                                    <!-- <span  class="text-red-plus">*</span> -->
                                    </span>
                                </div>

                            </div>
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" *ngIf="subVehiculeCategories?.length > 0 ||  categorieVehicule ">
                                <div class="semi">
                                    <input type="text" name='prenom' formControlName="numeroChassis" placeholder="Numéro de châssis du véhicule">
                                    <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                                    <img src="assets/images/icon-marque-auto.svg" alt="">
                                    <!-- <span  class="text-red-plus">*</span> -->
                                    </span>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" *ngIf="(subVehiculeCategories?.length > 0 ||  categorieVehicule) && shoModel">
                                <div class="semi">
                                    <ng-select formControlName="marque" (change)="marque()" clearAllText="Effacer tout" notFoundText="Aucun élément trouvé" [dropdownPosition]="'bottom'" [items]="listMarques" bindLabel="make" bindValue="make" class="custom" placeholder="Marque du vehicule"
                                        typeToSearchText="Taper pour rechercher">
                                    </ng-select>
                                    <span class="img-form2" placement="top" triggers="mouseenter:mouseleave">
                                    <img src="assets/images/icon-marque-auto.svg" alt="">
                                    <!-- <span  class="text-red-plus">*</span> -->
                                    </span>
                                </div>

                            </div>
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" *ngIf="(subVehiculeCategories?.length > 0 ||  categorieVehicule) && simulationVehiculeForm.get('marque').valid && shoModel && !autreMarqueSelected">
                                <div class="semi">
                                    <ng-select formControlName="modele" clearAllText="Effacer tout" notFoundText="Aucun élément trouvé" [dropdownPosition]="'bottom'" [items]="listModeles" bindLabel="model" bindValue="model" class="custom" placeholder="Modèle du vehicule" typeToSearchText="Taper pour rechercher">
                                    </ng-select>
                                    <span class="img-form2" placement="top" triggers="mouseenter:mouseleave">
                                    <img src="assets/images/icon-marque-auto.svg" alt="">
                                    <!-- <span  class="text-red-plus">*</span> -->
                                    </span>
                                </div>
                            </div>
                            
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" *ngIf="(subVehiculeCategories?.length > 0 ||  categorieVehicule) && (!shoModel || autreMarqueSelected)">
                                <div class="semi">
                                    <input type="text" formControlName="autreMarque" name='secteur_activite' placeholder="Autre marque du véhicule">
                                    <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                                    <img src="assets/images/icon-marque-auto.svg" alt="">
                                    <!-- <span  class="text-red-plus">*</span> -->
                                    </span>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" *ngIf="(subVehiculeCategories?.length > 0 ||  categorieVehicule) && (!shoModel || autreMarqueSelected || autreModelSelected)">
                                <div class="semi">
                                    <input type="text" formControlName="autreModele" name='secteur_activite' placeholder="Autre modèle du véhicule">
                                    <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                                    <img src="assets/images/icon-marque-auto.svg" alt="">
                                    <!-- <span  class="text-red-plus">*</span> -->
                                    </span>
                                </div>
                            </div>
                        
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" *ngIf="subVehiculeCategories?.length > 0 ||  categorieVehicule">
                                <div class="semi">
                                    <input type="text" [maxDate]="newDate" formControlName="date_mis_en_circulation" #dateItem="bsDatepicker" [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name="date" placeholder="Date de mise en circulation">
                                    <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                                    <img src="assets/images/icon-date.svg" alt="">
                                    <!-- <span class="text-red-plus">*</span> -->
                                    </span>
                                </div>

                            </div>
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" *ngIf="subVehiculeCategories?.length > 0 ||  categorieVehicule">
                                <div class="semi">
                                    <input type="text" [minDate]="newDate" formControlName="date_effet" #dateItem="bsDatepicker" [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name="date" placeholder="Date d'effet du contrat">
                                    <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                                    <img src="assets/images/icon-date.svg" alt="">
                                    <!-- <span class="text-red-plus">*</span> -->
                                    </span>
                                </div>
                            </div>
                            
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" *ngIf="subVehiculeCategories?.length > 0 ||  categorieVehicule">
                                <div class="semi">
                                    <ng-select formControlName="duree" (change)="checkDuree()" clearAllText="Effacer tout" notFoundText="Aucun élément trouvé" [dropdownPosition]="'bottom'" [items]="listDureesFiltrer" bindLabel="displayMe"
                                        bindValue="duree" class="custom" placeholder="Durée du contrat" typeToSearchText="Taper pour rechercher" #vehicule>
                                    </ng-select>
                                    <span class="img-form2" placement="top" triggers="mouseenter:mouseleave">
                                    <img src="assets/images/nom.svg" alt="">
                                    <!-- <span  class="text-red-plus">*</span> -->
                                    </span>
                                </div>
                            </div>
                        
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" *ngIf="subVehiculeCategories?.length > 0 ||  categorieVehicule">
                                <div class="semi">
                                    <input type="text" [minDate]="newDate" formControlName="dateEcheance" #dateItem="bsDatepicker" [bsConfig]="{dateInputFormat: 'DD-MM-YYYY',locale: 'fr' }" bsDatepicker name="date" placeholder="Date fin du contrat">
                                    <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                                    <img src="assets/images/icon-date.svg" alt="">
                                    <!-- <span class="text-red-plus">*</span> -->
                                    </span>
                                </div>
                            </div>
                <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12" *ngIf="categorieVehicule">
                    <div class="formulaire">
                        <div class="input-radio">
                            <div class="row">
                                <div class="isLabel">CEDEAO</div>
                                <div class="col-md-4 col-sm-6 col-xs-12" *ngFor="let item of cedeaoOption">
                                <input type="radio" [id]="item.value" [value]="item.value" formControlName="cedeao" />
                                <label [for]="item.value">{{item.name}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>            

            

                        </div>
                    </div>
                    </div>

                    <div class="col-6 col-lg-6 col-md-6 col-sm-12 mb-3">  
                              <div class="form-container c-form-container" *ngIf="garantieShow" style="margin-top: 23px;">
                        <h4 class="section-title">Choix des garanties</h4>
                        <div class="row">
                            <div class="col-12 text-center p-2 mrhgarantie">
                                <b class="c-respon">Responsabilité civile des conducteurs (Garantie par défaut)</b>
                            </div>
                        </div>
                        <div *ngIf="garanties?.length > 0" class="row input-checkbox">
                            <div class="col-lg-6 col-md-6 col-sm-12 mb-3" *ngFor="let g of garanties">
                                <div class="form-group">
                                    <div *ngIf="g.sousGarantie.length==0">
                                        <div class="">
                                            <input type="checkbox" class="" [disabled]="g.disabled" [checked]="g.selected" (change)="addGarantie(g,g.sousGarantie)" id="{{g.code}}" [value]="g" name="{{g.code}}">
                                            <label class="label-garantie" for="{{g.code}}"> {{g?.nom}} <span class="garantDescription" placement="right" triggers="click">?</span></label>
                                        </div>
                                    </div>
                                    <div *ngIf="g.sousGarantie.length>0">
                                        <label class="label-SG"> {{g?.nom}}</label>
                                        <div class="ml-3" style="margin-bottom: 30px !important;">
                                            <div *ngFor="let sg of g.sousGarantie" class="custom-control custom-radio sgGarantie">
                                                <input type="radio" class="custom-control-input inputCheck" [checked]="sg.selected" (change)="addGarantie(sg,sg,g.sousGarantie)" id="{{sg.code}}" [value]="sg" name="{{g.code}}">
                                                <label class="custom-control-label" for="{{sg.code}}" *ngIf="checkDescription(sg?.nom) <= 20">
                                                    {{sg?.nom | slice : 0 : 20}}
                                                </label>
                                                <label title="{{sg?.nom}}" class="custom-control-label" for="{{sg.code}}" *ngIf="checkDescription(sg?.nom) > 20">
                                                    {{sg?.nom | slice : 0 : 21}} ...
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="noDataGaranties" *ngIf="garanties?.length == 0 ">
                            Chargement en cours ...
                        </div>
                        <div class="row formulaire" style="margin-top: 20px !important;">
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" *ngIf="complete || collision || plafone">
                                <div class="semi">
                                    <input type="text" [mask]="'separator'" name="neuf" formControlName="valeurNeuf" placeholder="Valeur à neuf" (blur)="setValeurVenale()" (keyup)="onBlurEventneuf($event)">
                                    <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                                    <img src="assets/images/icon-valeur-locative.svg" alt="">
                                    </span>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12" *ngIf="incendie || collision || vol || plafone">
                                <div class="semi">
                                    <input type="text" [mask]="'separator'" name="neuf" formControlName="valeurVenal" placeholder="Valeur venale">
                                    <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                                    <img src="assets/images/icon-valeur-locative.svg" alt="">
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>

                </div>

                    <div class="step-navigation">
                    <button class="btn-back" awPreviousStep (click)="retour()">
                        <img src="assets/images/icon-bouton-precedent.svg" alt="Précédent">
                        Retour
                    </button>
                    <button class="btn-continue" (click)="validerVehiculeEtGaranties()">
                        Continuer
                        <img src="assets/images/icon-bouton-suivant.svg" alt="Suivant">
                    </button>
                </div>


                </aw-wizard-step>

               
            <aw-wizard-step [navigationSymbol]="{ symbol: '3' }" stepTitle="Assureur">
                    <!-- Section principale des offres -->
                    <div class="step-container" *ngIf="!isSouscription">
                        <div class="step-header">
                        <h2>Nos meilleures offres pour vous</h2>
                        <p class="step-subtitle">Sélectionnez l'assureur de votre choix</p>
                        </div>
                        <div class="insurers-container">
                        <div class="loading-section" *ngIf="sendingRequestAssureur && ((resultSimulationNew.length === 0 && !assureurOtherShow) || (tarificationList.length === 0 && assureurOtherShow))">
                            <div class="loading-spinner">
                            <i class="fa fa-spinner fa-pulse"></i>
                            </div>
                            <p class="loading-text">Recherche des meilleures offres en cours...</p>
                        </div>
                        <!-- Aucune proposition -->
                        <div class="no-offers-section" *ngIf="!sendingRequestAssureur && ((resultSimulationNew.length === 0 && !assureurOtherShow) || (tarificationList.length === 0 && assureurOtherShow))">
                            <!-- <div class="no-offers-icon">
                            <i class="fa fa-exclamation-triangle"></i>
                            </div> -->
                            <p class="no-offers-subtitle text-center">Veuillez vérifier vos informations ou réessayer plus tard</p>
                        </div>
                        <!-- Grille des offres - Version normale -->
                        <div class="offers-grid" *ngIf="!assureurOtherShow && resultSimulationNew.length > 0">
                            <div class="offer-card" 
                                *ngFor="let offer of resultSimulationNew"
                                (click)="goToNext(offer)"
                                [class.featured]="offer?.featured">
                            <div class="offer-header">
                                <div class="insurer-logo bg-{{offer?.assureur?.code}}">
                                <img class="insurer-logo" 
                                    [src]="offer?.assureur?.logo" 
                                    [alt]="offer?.assureur?.nom"
                                    loading="lazy">
                                </div>
                                <div class="offer-badge" *ngIf="offer?.recommended">
                                <span>Recommandé</span>
                                </div>
                            </div>
                            <div class="offer-content">
                                <h3 class="insurer-name">{{offer?.assureur?.nom}}</h3>
                                <div class="price-section">
                                <div class="price-item" *ngFor="let item of offer?.simulation">
                                    <div *ngIf="item.key === 'Prime Totale TTC'" class="total-price">
                                    <span class="price-amount">{{item?.value | number:'1.0-0':'fr'}}</span>
                                    <span class="currency">FCFA</span>
                                    </div>
                                </div>
                                </div>
                                <div class="offer-details" *ngIf="offer?.highlights">
                                <ul class="highlights-list">
                                    <li *ngFor="let highlight of offer.highlights">
                                    <i class="fa fa-check"></i>
                                    <span>{{highlight}}</span>
                                    </li>
                                </ul>
                                </div>
                                <button class="select-offer-btn" type="button">
                                <span>Souscrire en ligne</span>
                                </button>
                            </div>
                            </div>
                        </div>
                        <!-- Grille des offres - Version transport public -->
                        <div class="offers-grid" *ngIf="assureurOtherShow && tarificationList.length > 0">
                            <div class="offer-card" 
                                *ngFor="let offer of tarificationList"
                                (click)="goToNext(offer)"
                                [class.featured]="offer?.featured">
                            <div class="offer-header">
                                <div class="insurer-logo bg-{{offer?.assureur?.nom}}">
                                <img class="insurer-logo" 
                                    [src]="offer?.assureur?.uuid" 
                                    [alt]="offer?.assureur?.nom"
                                    loading="lazy">
                                </div>
                                <div class="offer-badge" *ngIf="offer?.recommended">
                                <span>Recommandé</span>
                                </div>
                            </div>
                            <div class="offer-content">
                                <h3 class="insurer-name">{{offer?.assureur?.nom}}</h3>
                                <div class="price-section">
                                <div class="total-price">
                                    <span class="price-amount">{{offer?.primeTTC | number:'1.0-0':'fr'}}</span>
                                    <span class="currency">FCFA</span>
                                </div>
                                </div>
                                <div class="offer-type">
                                <span class="type-badge">Transport Public</span>
                                </div>
                                <button class="select-offer-btn" type="button">
                                <span>Souscrire en ligne</span>
                                </button>
                            </div>
                            </div>
                        </div>
                        <div class="processing-section" *ngIf="sendingRequest">
                            <div class="processing-spinner">
                            <i class="fa fa-spinner fa-pulse"></i>
                            </div>
                            <p class="processing-text">Traitement de votre demande en cours...</p>
                        </div>
                        </div>
                        <!-- Navigation -->
                        <div class="step-navigation">
                        <button class="btn-back" awPreviousStep (click)="retour()" type="button">
                            <span>Retour</span>
                        </button>

                        <!-- Bouton Continuer quand pas d'offres -->
                        <button class="btn-continue" 
                                *ngIf="!sendingRequestAssureur && ((resultSimulationNew.length === 0 && !assureurOtherShow) || (tarificationList.length === 0 && assureurOtherShow))"
                                (click)="continuerSansAssureur()" 
                                type="button">
                            <span>Continuer sans assureur</span>
                            <img src="assets/images/icon-bouton-suivant.svg" alt="Suivant">
                        </button>
                        </div>
                    </div>
            </aw-wizard-step>

                <aw-wizard-step [navigationSymbol]="{ symbol: '4' }" stepTitle="Paiement" *ngIf="showPaiement">
                    <section class="">
                        <div class="row mySelectRelais formulaire justify-content-center">
                            <div class="input-box" style="width: 390px !important;">
                                <ng-select (change)="moyenPayement($event)" [(ngModel)]="paysSelected" [ngModelOptions]="{standalone: true}" clearAllText="Effacer tout" notFoundText="Aucun élément trouvé" [dropdownPosition]="'bottom'" [items]="paysList" bindLabel="name" bindValue="value"
                                    class="custom" placeholder="Pays" typeToSearchText="Taper pour rechercher" #vehicule>
                                </ng-select>
                                <span class="img-form2" placement="top" triggers="mouseenter:mouseleave">
                                <img src="assets/images/icon-adresse.svg" alt="">
                                <!-- <span  class="text-red-plus">*</span> -->
                                </span>
                            </div>
                        </div>
                    </section>
                    <div class="row mb-2 justify-content-center">
                        <h6 class="col-12 text-center colorChoisir">Choisir un moyen de paiement</h6>
                    </div>
                    <section class="">
                        <div class="container mt-5">
                            <div class="row justify-content-center">
                                <div class="col-md-3 col-lg-2 cardB" *ngFor="let pay of paysPaiement" (click)="selectPayment(pay)">
                                    <div class="image-container">
                                        <div class="first">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <!-- <i class="fa fa-check-circle mr-2 text-success sixCheck" *ngIf="simulationVehiculeForm.get('moyenDePaiement').value == pay.code"></i> -->
                                                <img src="assets/images/checked.png" alt="" *ngIf="simulationVehiculeForm.get('moyenDePaiement').value == pay.code">
                                            </div>
                                        </div> <img [src]="pay.image" class="img-fluid rounded thumbnail-image tailImgB">
                                    </div>
                                    <div class="product-detail-container p-2">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <h5 class="dress-name">{{pay?.name}}</h5>
                                            <div class="d-flex flex-column mb-2"> <span class="new-price"></span> <small class="old-price text-right"></small> </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                <div class="step-navigation">
                    <button class="btn-back" awPreviousStep (click)="retour()">
                            <img src="assets/images/icon-bouton-precedent.svg" alt="Précédent">
                            Retour
                    </button>
                    <button class="btn-continue" (click)="assureeNew2()">
                            Continuer
                            <img src="assets/images/icon-bouton-suivant.svg" alt="Suivant">
                    </button>
                </div>

                </aw-wizard-step>

                <aw-wizard-step [navigationSymbol]="{ symbol: '4' }" stepTitle="Paiement" *ngIf="!showPaiement">
                  <div class="recap-form-container" *ngIf="currentStep != 4">
                        <div class="mesImage">
                            <div class="imgLogo">
                                <img src="assets/images/logo.png" alt="Logo">
                            </div>
                        </div>
                        <div class="info-devis">
                            <div class="proposition">
                                <div class="pro-title">Devis automobile</div>
                                <div class="sub-title">{{numeroSous}}</div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6" style="flex: 0 0 50% !important;">
                                    <div class="title-div">
                                        <span>Souscripteur</span>
                                    </div>
                                    <div class="contenu-div">
                                        <div class="row">
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Numéro</div>
                                                <div class="col-7 value">{{numeroSous}}</div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Prénom</div>
                                                <div class="col-7 value">
                                                     {{simulationVehiculeForm?.get('assure')?.get('prenom')?.value}}
                                                </div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Nom</div>
                                                <div class="col-7 value">
                                                    {{simulationVehiculeForm.get('assure').get('nom').value}}
                                                </div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Email</div>
                                                <div class="col-7 value">{{simulationVehiculeForm?.get('assure')?.get('email')?.value}}</div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Téléphone</div>
                                                <div class="col-7 value">
                                                     {{simulationVehiculeForm?.get('assure')?.get('numeroTelephone')?.value}}
                                                </div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Adresse</div>
                                                <div class="col-7 value">
                                                    {{simulationVehiculeForm?.get('assure')?.get('adresse')?.value}}
                                                </div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Date de naissance</div>
                                                <div class="col-7 value">
                                                     {{simulationVehiculeForm?.get('assure')?.get('dateNaissance')?.value | date:'dd/MM/yyyy'}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6" style="flex: 0 0 50% !important;">
                                    <div class="title-div">
                                        <span>Références Proposition</span>
                                    </div>
                                    <div class="contenu-div">
                                        <div class="row">
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Numéro</div>
                                                <div class="col-7 value">{{refPro}}</div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Assuré(e)</div>
                                                <div class="col-7 value" *ngIf="simulationVehiculeForm?.get('assure')?.get('choix')?.value != 3">
                                                    {{simulationVehiculeForm?.get('assure')?.get('prenom')?.value}} {{simulationVehiculeForm.get('assure').get('nom').value}}
                                                </div>
                                                <div class="col-7 value" *ngIf="simulationVehiculeForm?.get('assure')?.get('choix')?.value == 3">
                                                    {{simulationVehiculeForm?.get('assure')?.get('raisonSociale')?.value}}
                                                </div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Adresse</div>
                                                <div class="col-7 value">{{simulationVehiculeForm?.get('assure')?.get('adresse')?.value}}</div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Email</div>
                                                <div class="col-7 value">{{simulationVehiculeForm?.get('assure')?.get('email')?.value}}</div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Téléphone</div>
                                                <div class="col-7 value">{{simulationVehiculeForm?.get('assure')?.get('numeroTelephone')?.value}}</div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Effet</div>
                                                <div class="col-7 value">{{simulationVehiculeForm?.get('date_effet')?.value | date:'dd/MM/yyyy'}}</div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Date d'expiration</div>
                                                <div class="col-7 value">{{simulationVehiculeForm.get('dateEcheance')?.value | date:'dd/MM/yyyy'}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 c-col-12">
                                    <div class="title-div">
                                        <span>Caractéristiques du véhicule</span>
                                    </div>
                                    <div class="contenu-div" *ngIf="!assureurOtherShow">
                                        <div class="row">
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                                                <div class="row">
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">N° immatriculation</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('immatriculation').value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Marque</div>
                                                        <div class="col-7 value" *ngIf="simulationVehiculeForm.get('marque').value !=''">
                                                            {{simulationVehiculeForm.get('marque').value}}
                                                        </div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Catégorie</div>
                                                        <div class="col-7 value">{{currentCategorie}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Puissance (CV)</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('puissance').value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex" *ngIf="simulationVehiculeForm.get('valeurNeuf').value">
                                                        <div class="col-5 name">Valeur à neuf</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('valeurNeuf').value | number:'1.0-0':'fr' }}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Energie</div>
                                                        <div class="col-7 value c-value">{{simulationVehiculeForm.get('typeMoteur').value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Nombre de places</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('nombrePlace').value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex" *ngIf="simulationVehiculeForm.get('poids').value">
                                                        <div class="col-5 name">Charge utile (Kg)</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('poids').value}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                                                <div class="row">
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">1ère mise en circulation</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('date_mis_en_circulation').value | date:'dd/MM/yyyy'}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Modéle</div>
                                                        <div class="col-7 value" *ngIf="simulationVehiculeForm.get('modele').value !=''">
                                                            {{simulationVehiculeForm.get('modele').value}}
                                                        </div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Puissance réelle (cm3)</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('puissance').value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex" *ngIf="simulationVehiculeForm.get('valeurVenal').value">
                                                        <div class="col-5 name">Valeur vénale</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('valeurVenal').value | number:'1.0-0':'fr'}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Date immatriculation</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('date_mis_en_circulation').value | date:'dd/MM/yyyy'}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Zone</div>
                                                        <div class="col-7 value">{{currentFiliale?.pays}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="contenu-div" *ngIf="assureurOtherShow">
                                        <div class="row">
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                                                <div class="row">
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">N° immatriculation</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm?.get('immatriculation')?.value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Marque</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm?.get('autreMarque')?.value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Catégorie</div>
                                                        <div class="col-7 value">{{currentCategorie}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Puissance (CV)</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm?.get('puissance')?.value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Energie</div>
                                                        <div class="col-7 value c-value">{{simulationVehiculeForm?.get('typeMoteur')?.value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Nombre de places</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm?.get('nombrePlace')?.value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Charge utile (Kg)</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm?.get('poids')?.value}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                                                <div class="row">
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">1ère mise en circulation</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('date_mis_en_circulation')?.value | date:'dd/MM/yyyy'}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Modéle</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('autreModele')?.value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Date immatriculation</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('date_mis_en_circulation')?.value | date:'dd/MM/yyyy'}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Zone</div>
                                                        <div class="col-7 value">Côte d'Ivoire</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                         
                          
                        </div>
                    </div>

                    <div class="step-navigation" *ngIf="currentStep != 4">
                       <button class="btn-back" awPreviousStep (click)="retour()">
                          <img src="assets/images/icon-bouton-precedent.svg" alt="Précédent">
                           Retour
                        </button>
                        <button type="button" class="btn-continue final-btn" [swal]="confirmSubscription3" [disabled]="sendingRequest">
                           <i class="fa fa-spinner fa-pulse" *ngIf="sendingRequest"></i>
                           <span *ngIf="!sendingRequest">Soumettre</span>
                           <span *ngIf="sendingRequest">Traitement en cours...</span>
                           <img src="assets/images/icon-bouton-suivant.svg" alt="Suivant">
                        </button>
                    </div>

                    <div class="step-container_other" *ngIf="currentStep === 4">
                        <div class="success-auto">
                            <div class="icon-succes">
                            <img width="10%" src="/assets/images/verifier.png" alt="" srcset="">
                            </div>
                            <div class="message-success">
                             Votre demande a été soumise avec succès. Vous recevrez un devis sous 48h. Merci pour la confiance.
                            <span>L'équipe d'Inclusive Guarantee</span>
                            </div>
                            <button class="btn-success" (click)="souscrireAutomobile()">
                            <span>Nouvelle demande</span>
                            </button>
                        </div>
                    </div>

                </aw-wizard-step>

                <aw-wizard-step [navigationSymbol]="{ symbol: '5' }" stepTitle="Récapitulatif">
                    <div class="recap-form-container">
                        <div class="mesImage">
                            <div class="imgLogo" *ngIf="!assureurOtherShow">
                                <img [src]="rest?.assureur?.logo" [alt]="rest?.assureur?.nom">
                            </div>
                            <div class="imgLogo" *ngIf="assureurOtherShow">
                                <img [src]="rest?.assureur?.uuid" [alt]="rest?.assureur?.nom">
                            </div>
                            <div class="imgLogo">
                                <img src="assets/images/logo.png" alt="Logo">
                            </div>
                        </div>
                        <div class="info-devis">
                            <div class="proposition">
                                <div class="pro-title">Devis automobile</div>
                                <div class="sub-title">{{numeroSous}}</div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6" style="flex: 0 0 50% !important;">
                                    <div class="title-div">
                                        <span>Souscripteur</span>
                                    </div>
                                    <div class="contenu-div">
                                        <div class="row">
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Numéro</div>
                                                <div class="col-7 value">{{numeroSous}}</div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Prénom</div>
                                                <div class="col-7 value">
                                                    <!-- {{user?.infos?.firstName}} {{user?.infos?.lastName}} -->
                                                     {{simulationVehiculeForm?.get('assure')?.get('prenom')?.value}}
                                                </div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Nom</div>
                                                <div class="col-7 value">
                                                    <!-- {{user?.infos?.firstName}} {{user?.infos?.lastName}} -->
                                                    {{simulationVehiculeForm.get('assure').get('nom').value}}
                                                </div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Email</div>
                                                <div class="col-7 value">{{simulationVehiculeForm?.get('assure')?.get('email')?.value}}</div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Téléphone</div>
                                                <div class="col-7 value">
                                                    <!-- {{user?.infos?.telephone}} -->
                                                     {{simulationVehiculeForm?.get('assure')?.get('numeroTelephone')?.value}}
                                                </div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Adresse</div>
                                                <div class="col-7 value">
                                                    <!-- {{user?.infos?.adresse}} -->
                                                    {{simulationVehiculeForm?.get('assure')?.get('adresse')?.value}}
                                                </div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Date de naissance</div>
                                                <div class="col-7 value">
                                                     {{simulationVehiculeForm?.get('assure')?.get('dateNaissance')?.value | date:'dd/MM/yyyy'}}
                                                </div>
                                            </div>
                                            <!-- <div class="col-12 d-flex">
                                                <div class="col-5 name">Activité</div>
                                                <div class="col-7 value">{{user?.infos?.secteuractivite}}</div>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6" style="flex: 0 0 50% !important;">
                                    <div class="title-div">
                                        <span>Références Proposition</span>
                                    </div>
                                    <div class="contenu-div">
                                        <div class="row">
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Numéro</div>
                                                <div class="col-7 value">{{refPro}}</div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Assuré(e)</div>
                                                <div class="col-7 value" *ngIf="simulationVehiculeForm?.get('assure')?.get('choix')?.value != 3">
                                                    {{simulationVehiculeForm?.get('assure')?.get('prenom')?.value}} {{simulationVehiculeForm.get('assure').get('nom').value}}
                                                </div>
                                                <div class="col-7 value" *ngIf="simulationVehiculeForm?.get('assure')?.get('choix')?.value == 3">
                                                    {{simulationVehiculeForm?.get('assure')?.get('raisonSociale')?.value}}
                                                </div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Adresse</div>
                                                <div class="col-7 value">{{simulationVehiculeForm?.get('assure')?.get('adresse')?.value}}</div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Email</div>
                                                <div class="col-7 value">{{simulationVehiculeForm?.get('assure')?.get('email')?.value}}</div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Téléphone</div>
                                                <div class="col-7 value">{{simulationVehiculeForm?.get('assure')?.get('numeroTelephone')?.value}}</div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Effet</div>
                                                <div class="col-7 value">{{simulationVehiculeForm?.get('date_effet')?.value | date:'dd/MM/yyyy'}}</div>
                                            </div>
                                            <div class="col-12 d-flex">
                                                <div class="col-5 name">Date d'expiration</div>
                                                <div class="col-7 value">{{simulationVehiculeForm.get('dateEcheance')?.value | date:'dd/MM/yyyy'}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 c-col-12">
                                    <div class="title-div">
                                        <span>Caractéristiques du véhicule</span>
                                    </div>
                                    <div class="contenu-div" *ngIf="!assureurOtherShow">
                                        <div class="row">
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                                                <div class="row">
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">N° immatriculation</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('immatriculation').value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Marque</div>
                                                        <div class="col-7 value" *ngIf="simulationVehiculeForm.get('marque').value !=''">
                                                            {{simulationVehiculeForm.get('marque').value}}
                                                        </div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Catégorie</div>
                                                        <div class="col-7 value">{{currentCategorie}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Puissance (CV)</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('puissance').value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex" *ngIf="simulationVehiculeForm.get('valeurNeuf').value">
                                                        <div class="col-5 name">Valeur à neuf</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('valeurNeuf').value | number:'1.0-0':'fr' }}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Energie</div>
                                                        <div class="col-7 value c-value">{{simulationVehiculeForm.get('typeMoteur').value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Nombre de places</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('nombrePlace').value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex" *ngIf="simulationVehiculeForm.get('poids').value">
                                                        <div class="col-5 name">Charge utile (Kg)</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('poids').value}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                                                <div class="row">
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">1ère mise en circulation</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('date_mis_en_circulation').value | date:'dd/MM/yyyy'}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Modéle</div>
                                                        <div class="col-7 value" *ngIf="simulationVehiculeForm.get('modele').value !=''">
                                                            {{simulationVehiculeForm.get('modele').value}}
                                                        </div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Puissance réelle (cm3)</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('puissance').value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex" *ngIf="simulationVehiculeForm.get('valeurVenal').value">
                                                        <div class="col-5 name">Valeur vénale</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('valeurVenal').value | number:'1.0-0':'fr'}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Date immatriculation</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('date_mis_en_circulation').value | date:'dd/MM/yyyy'}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Zone</div>
                                                        <div class="col-7 value">Côte d'Ivoire</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="contenu-div" *ngIf="assureurOtherShow">
                                        <div class="row">
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                                                <div class="row">
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">N° immatriculation</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm?.get('immatriculation')?.value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Marque</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm?.get('autreMarque')?.value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Catégorie</div>
                                                        <div class="col-7 value">{{currentCategorie}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Puissance (CV)</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm?.get('puissance')?.value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Energie</div>
                                                        <div class="col-7 value c-value">{{simulationVehiculeForm?.get('typeMoteur')?.value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Nombre de places</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm?.get('nombrePlace')?.value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Charge utile (Kg)</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm?.get('poids')?.value}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                                                <div class="row">
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">1ère mise en circulation</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('date_mis_en_circulation')?.value | date:'dd/MM/yyyy'}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Modéle</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('autreModele')?.value}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Date immatriculation</div>
                                                        <div class="col-7 value">{{simulationVehiculeForm.get('date_mis_en_circulation')?.value | date:'dd/MM/yyyy'}}</div>
                                                    </div>
                                                    <div class="col-12 d-flex">
                                                        <div class="col-5 name">Zone</div>
                                                        <div class="col-7 value">Côte d'Ivoire</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="proposition2" *ngIf="!assureurOtherShow">
                                <div class="pro-title"> Garanties souscrites et Primes d’assurance (en FCFA)</div>
                            </div>
                            <div class="row" *ngIf="!assureurOtherShow">
                                <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 c-col-122">

                                    <div class="contenu-div">
                                        <div class="row">
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-prime">
                                                <div class="title-div-gar">
                                                    Nature des garanties
                                                </div>
                                                <div *ngFor="let garantie of garantieAss">
                                                    {{garantie?.key == 'Prime RC' ? 'Responsabilité Civile' : garantie?.key }}
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                                                <div class="title-div-gar1">
                                                    Primes d’assurance
                                                </div>
                                                <div class="val" *ngFor="let garantie of garantieAss">
                                                    <span>{{garantie?.value |number:'1.0-0':'fr'}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="description-ass" *ngIf="!assureurOtherShow">
                                Par conséquant, le souscripteur s'engage à payer au comptant à la signature du présent contrat la somme de <b> {{tot | number:'1.0-0':'fr'}} FCFA</b> décomptée comme suit:
                            </div>
                            <div class="row" *ngIf="!assureurOtherShow">
                                <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 c-col-122">
                                    <div class="contenu-div">
                                        <div class="row">
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-prime">
                                                <div *ngFor="let item of primeAss">
                                                    <span *ngIf="item.key!='Prime Totale TTC' && item.key != 'Prime RC'">{{item?.key == 'Prime RC'
                                                        ? 'Responsabilité Civile' : item?.key}} (FCFA)</span>
                                                    <span *ngIf="item.key=='Prime Totale TTC'" class="valPrime">Prime
                                                        TTC (FCFA)</span>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                                                <div class="val" *ngFor="let item of primeAss">
                                                    <span *ngIf="item.key!='Prime Totale TTC' && item.key != 'Prime RC'">{{item.value |
                                                        number:'1.0-0':'fr'}}</span>
                                                    <span *ngIf="item.key=='Prime Totale TTC'" class="valPrime">{{item.value | number:'1.0-0':'fr'}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="assureurOtherShow">
                                <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 c-col-122">
                                    <div class="contenu-div">
                                        <div class="row">
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-prime">
                                                <div>
                                                    <span class="valPrime">Prime TTC (FCFA)</span>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                                                <div class="val">
                                                    <span class="valPrime">{{rest?.primeTTC | number:'1.0-0':'fr'}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="disposition row col-md-12 col-lg-12 col-sm-12 col-xs-12" *ngIf="!assureurOtherShow">
                                <div class="title-dispo-footerL col-md-6 col-lg-6 col-sm-12 col-xs-12">
                                    Assureur : {{currentAssureur?.nom}}
                                </div>
                                <div class="title-dispo-footerR col-md-6 col-lg-6 col-sm-12 col-xs-12">
                                    Date emission : {{newDate |date:'dd/MM/yyyy' }} E-MAIL : contact@inclusiveguarantee.fr
                                </div>
                            </div>
                            <div class="disposition row col-md-12 col-lg-12 col-sm-12 col-xs-12" *ngIf="assureurOtherShow">
                                <div class="title-dispo-footerL col-md-6 col-lg-5 col-sm-12 col-xs-12">
                                    Assureur : {{rest?.assureur?.nom}}
                                </div>
                                <div class="title-dispo-footerR col-md-6 col-lg-7 col-sm-12 col-xs-12">
                                    Date emission : {{newDate |date:'dd/MM/yyyy' }} E-MAIL : contact@inclusiveguarantee.fr
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="step-navigation">
                       <button class="btn-back" awPreviousStep (click)="retour()">
                          <img src="assets/images/icon-bouton-precedent.svg" alt="Précédent">
                           Retour
                        </button>
                        <button type="button" class="btn-continue final-btn" [swal]="confirmSubscription2" [disabled]="sendingRequest">
                           <i class="fa fa-spinner fa-pulse" *ngIf="sendingRequest"></i>
                           <span *ngIf="!sendingRequest">Soumettre</span>
                           <span *ngIf="sendingRequest">Traitement en cours...</span>
                           <img src="assets/images/icon-bouton-suivant.svg" alt="Suivant">
                        </button>
                    </div>

                </aw-wizard-step>
                
            </aw-wizard>
        </form>
    </div>
</div>



<!-- newwwwwwwwwwwwwwwwwwwwww -->

<!-- Modal pour la page login -->
<ng-template #contentResultlogin let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Connectez vous à votre compte SVP.</h5>
        <button class="close text-primary text-right loginclose" aria-label="Close" (click)="modal.dismiss('close')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="formulaire">
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-6 col-xs-12">
                    <form [formGroup]="loginform">
                        <div class="cust_input_box">
                            <input type="text" name='nom' formControlName="username" placeholder="Nom d'utilisateur">
                            <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                        <img src="assets/images/nom.svg" alt="">
                        <span class="text-red-plus">*</span>
                            </span>
                        </div>
                        <div class="cust_input_box">
                            <input type="password" name='nom' formControlName="password" placeholder="Mot de passe">
                            <span class="img-form" placement="top" triggers="mouseenter:mouseleave">
                        <img src="assets/images/nom.svg" alt="">
                        <span  class="text-red-plus">*</span>
                            </span>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
   


</ng-template>

<!-- Modal pour pdf de souscription -->
<ng-template #contentResultass let-modal>
    <div class="modal-body  bg-white  autodown" #autoDownload1 id="autoDownload">
        <div class="mesImage">
            <div class="imgLogo" *ngIf="!assureurOtherShow">
                <img [src]="rest?.assureur?.logo" [alt]="rest?.assureur?.nom">
            </div>
            <div class="imgLogo" *ngIf="assureurOtherShow">
                <img [src]="rest?.assureur?.uuid" [alt]="rest?.assureur?.nom">
            </div>
            <div class="imgLogo">
                <img [src]="logoImage" alt="Logo">
            </div>
        </div>
        <div class="info-devis container">
            <div class="proposition">
                <div class="pro-title">Devis automobile</div>
                <div class="sub-title">{{numeroSous}}</div>
            </div>
            <div class="row ">
                <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6">
                    <div class="title-div">
                        <span>Souscripteur</span>
                    </div>
                    <div class="contenu-div">
                        <div class="row">
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Numéro</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value"> {{numeroSous}} </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Nom</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                {{ simulationVehiculeForm?.get('assure')?.get('prenom')?.value}} {{ simulationVehiculeForm?.get('assure')?.get('nom')?.value}} </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Email</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                {{ simulationVehiculeForm?.get('assure')?.get('email')?.value}} </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Téléphone</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                {{simulationVehiculeForm?.get('assure')?.get('numeroTelephone')?.value}} </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Adresse</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                {{simulationVehiculeForm?.get('assure')?.get('adresse')?.value}}
                            </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Profession</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                {{simulationVehiculeForm?.get('assure')?.get('profession')?.value}}
                            </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Activité</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                {{simulationVehiculeForm?.get('assure')?.get('secteuractivite')?.value}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6">
                    <div class="title-div">
                        <span> Références Proposition</span>
                    </div>
                    <div class="contenu-div">
                        <div class="row">
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Numéro</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value"> {{refPro}} </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Assuré(e)</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value" *ngIf="simulationVehiculeForm?.get('assure')?.get('choix')?.value != 3">
                                {{ simulationVehiculeForm?.get('assure')?.get('prenom')?.value}} {{ simulationVehiculeForm?.get('assure')?.get('nom')?.value}}
                            </div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value" *ngIf="simulationVehiculeForm?.get('assure')?.get('choix')?.value == 3">
                                {{ simulationVehiculeForm?.get('assure')?.get('raisonSociale')?.value}}
                            </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Adresse</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                {{ simulationVehiculeForm?.get('assure')?.get('adresse')?.value}}
                            </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Email</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                {{ simulationVehiculeForm?.get('assure')?.get('email')?.value}} </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Téléphone</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                {{simulationVehiculeForm?.get('assure')?.get('numeroTelephone')?.value}} </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Effet</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                {{simulationVehiculeForm?.get('date_effet')?.value | date:'dd/MM/yyyy HH:mm:ss'}} </div>
                            <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Date d'expiration</div>
                            <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                {{simulationVehiculeForm.get('dateEcheance')?.value | date:'dd/MM/yyyy'}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- not transport urbain -->
            <div class="row" *ngIf="!assureurOtherShow">
                <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 c-col-12">
                    <div class="title-div">
                        Caractéristiques du véhicule
                    </div>
                    <div class="contenu-div">
                        <div class="row">
                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 ">
                                <div class="row">
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">N° immatriculation</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                        {{simulationVehiculeForm?.get('immatriculation')?.value}} </div>
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Marque</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value" *ngIf="simulationVehiculeForm?.get('marque')?.value != ''">
                                        {{simulationVehiculeForm?.get('marque')?.value}}
                                    </div>
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Catégorie</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value"> {{currentCategorie}}
                                    </div>
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Puissance (CV)</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                        {{simulationVehiculeForm?.get('puissance')?.value}}
                                    </div>
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name" *ngIf="simulationVehiculeForm?.get('valeurNeuf')?.value">Valeur à neuf</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value" *ngIf="simulationVehiculeForm?.get('valeurNeuf')?.value">
                                        {{simulationVehiculeForm?.get('valeurNeuf')?.value | number:'1.0-0':'fr'}}
                                    </div>
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Energie</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value c-value">
                                        {{simulationVehiculeForm?.get('typeMoteur')?.value}} </div>
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Nombre de places</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                        {{simulationVehiculeForm?.get('nombrePlace')?.value}} </div>
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name"> Charge utile (Kg)</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                        {{simulationVehiculeForm?.get('poids')?.value}} </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                                <div class="row">
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">1ère mise en circulation
                                    </div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                        {{simulationVehiculeForm.get('date_mis_en_circulation')?.value |date:'dd/MM/yyyy'}} </div>

                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Modéle</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value" *ngIf="simulationVehiculeForm.get('modele')?.value!=''">
                                        {{simulationVehiculeForm.get('modele')?.value}}
                                    </div>
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name" *ngIf="simulationVehiculeForm.get('valeurVenal')?.value">Valeur vénale</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value" *ngIf="simulationVehiculeForm.get('valeurVenal')?.value">
                                        {{simulationVehiculeForm.get('valeurVenal')?.value | number:'1.0-0':'fr'}}
                                    </div>
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Date immatriculation</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                        {{simulationVehiculeForm.get('date_mis_en_circulation')?.value | date:'dd/MM/yyyy'}} </div>
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Zone</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value"> Côte d'Ivoire </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- not transport urbain -->
            <!-- transport urbain -->
            <div class="row" *ngIf="assureurOtherShow">
                <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 c-col-12">
                    <div class="title-div">
                        Caractéristiques du véhicule
                    </div>
                    <div class="contenu-div">
                        <div class="row">
                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 ">
                                <div class="row">
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">N° immatriculation</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                        {{simulationVehiculeForm?.get('immatriculation')?.value}} </div>
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Marque</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                        {{simulationVehiculeForm?.get('autreMarque')?.value}}
                                    </div>
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Catégorie</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value"> {{currentCategorie}}
                                    </div>
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Puissance (CV)</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                        {{simulationVehiculeForm?.get('puissance')?.value}} </div>
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Energie</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value c-value">
                                        {{simulationVehiculeForm?.get('typeMoteur')?.value}} </div>
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Nombre de places</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                        {{simulationVehiculeForm?.get('nombrePlace')?.value}} </div>
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name"> Charge utile (Kg)</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                        {{simulationVehiculeForm?.get('poids')?.value}} </div>
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                                <div class="row">
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">1ère mise en circulation
                                    </div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                        {{simulationVehiculeForm.get('date_mis_en_circulation')?.value |date:'dd/MM/yyyy'}}
                                    </div>
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Modéle</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                        {{simulationVehiculeForm.get('autreModele')?.value}}
                                    </div>
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Date immatriculation</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">
                                        {{simulationVehiculeForm.get('date_mis_en_circulation')?.value | date:'dd/MM/yyyy'}} </div>
                                    <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12 name">Zone</div>
                                    <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12 value">Côte d'Ivoire</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="!assureurOtherShow">
                <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 c-col-122">
                    <div class="contenu-div">
                        <div class="row">
                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-prime">
                                <div class="title-div-gar">
                                    Nature des garanties
                                </div>
                                <div *ngFor="let garantie of garantieAss">
                                    {{garantie?.key == 'Prime RC' ? 'Responsabilité Civile' : garantie?.key }}
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                                <div class="title-div-gar1">
                                    Primes d’assurance
                                </div>
                                <div class="val" *ngFor="let garantie of garantieAss">
                                    <span>{{garantie?.value |number:'1.0-0':'fr'}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="description-ass" *ngIf="!assureurOtherShow">
                Par conséquant, le souscripteur s'engage à payer au comptant à la signature du présent contrat la somme de <b>
                    {{tot | number:'1.0-0':'fr'}} FCFA</b> décomptée comme suit:
            </div>
            <div class="row" *ngIf="!assureurOtherShow">
                <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 c-col-122">

                    <div class="contenu-div">
                        <div class="row">
                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-prime">
                                <div *ngFor="let item of primeAss">
                                    <span *ngIf="item.key!='Prime Totale TTC' && item.key!='Prime RC'">{{item?.key}}</span>
                                    <span *ngIf="item.key=='Prime Totale TTC'" class="valPrime">Prime TTC FCFA</span>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                                <div class="val" *ngFor="let item of primeAss">
                                    <span *ngIf="item.key!='Prime Totale TTC' && item.key!='Prime RC'">{{item?.value |
                                        number:'1.0-0':'fr'}}</span>
                                    <span *ngIf="item.key=='Prime Totale TTC'" class="valPrime">{{item?.value |
                                        number:'1.0-0':'fr'}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="assureurOtherShow">
                <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 c-col-122">
                    <div class="contenu-div">
                        <div class="row">
                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-prime">
                                <div>
                                    <span class="valPrime">Prime TTC FCFA</span>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                                <div class="val">
                                    <span class="valPrime">{{rest.primeTTC | number:'1.0-0':'fr'}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- not transport urbain -->
            <div class="disposition row col-md-12 col-lg-12 col-sm-12 col-xs-12" *ngIf="!assureurOtherShow">
                <div class="title-dispo-footerL col-md-6 col-lg-6 col-sm-12 col-xs-12">
                    Assureur : {{currentAssureur?.nom}}
                </div>
                <div class="title-dispo-footerR col-md-6 col-lg-6 col-sm-12 col-xs-12">
                    Date emission : {{newDate |date:'dd/MM/yyyy HH:mm:ss' }}
                    <span class="emailmarg"> E-MAIL : contact&#64;inclusiveguarantee.com</span>
                </div>
            </div>
            <!-- not transport urbain -->
            <div class="disposition row col-md-12 col-lg-12 col-sm-12 col-xs-12" *ngIf="assureurOtherShow">
                <div class="title-dispo-footerL col-md-6 col-lg-6 col-sm-12 col-xs-12">
                    Assureur : {{rest?.assureur?.nom}}
                </div>
                <div class="title-dispo-footerR col-md-6 col-lg-6 col-sm-12 col-xs-12">
                    Date emission : {{newDate |date:'dd/MM/yyyy HH:mm:ss' }}
                    <span class="emailmarg"> E-MAIL : contact&#64;inclusiveguarantee.com</span>
                </div>
            </div>

        </div>
    </div>
    <div>
        <button type="button" class="btn btn-warning btn-prev c-btn-prev  pull-left c-roundbtn" (click)="modal.close('close')">
            <!-- <i class="fa fa-chevron-left"></i>  -->
            Retour</button>
        <button type="button" class="btn btn-primary btn-tel c-roundbtn" (click)="captureScreen()">Télécharger
                <i class="fa fa-download"></i></button>

    </div>

</ng-template>

<!-- Modal pour étre rappelé -->
<ng-template #devisAEnvoye let-modal>
    <form [formGroup]="etrerappeleForm">
        <div class="card card0 c-card">
            <div class="row no-margin">
                <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 c-headModal">
                    <div class="row no-margin">
                        <div class="col-10 p-0">
                            <h6 class="text-left text-white c-cardTitle">{{assureurAEnvoye?.displayMe}}</h6>
                        </div>
                        <div class="col-lg-2 text-right1">
                            <a aria-label="Close" (click)="modal.dismiss('close')" class="text-right"><i
                      class="fa fa-times text-white times-ass c-times-ass"></i></a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 mt-3">
                    <div class="row">

                        <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                            <div class="form" placement="top" ngbPopover="Date de rappel" triggers="mouseenter:mouseleave">
                                <i class="fa fa-calendar form__icon"></i>
                                <div class="form__separator">
                                </div>
                                <select id="date" placeholder="" class="form__select" name="date" formControlName="date" name="date" #vehicule>
                            <option value="" disabled selected>Jour de rappel</option>
                            <option *ngFor="let rapel of dateRappel" [value]="rapel.value">{{rapel?.name}}</option>
                          </select>
                                <label for="cars" class="form__label">Jour de rappel<span class="text-red"> *</span></label>
                            </div>
                            <div class="error min-max text-red" *ngIf="etrerappeleForm.get('date').invalid && updateRequest">
                                Ce champ est obligatoire
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                            <div class="form" placement="top" ngbPopover="Heure de rappel" triggers="mouseenter:mouseleave">
                                <i class="fa-regular fa-clock form__icon c-icon"></i>
                                <div class="form__separator">
                                </div>
                                <ngx-bootstrap-multiselect formControlName="heure" name="heure" class="form__select" [texts]="myTexts" [settings]="mySettings" #heure [options]="heureRappel"></ngx-bootstrap-multiselect>
                                <label for="cars" class="form__label">Heure de rappel<span class="text-red"> *</span></label>
                            </div>
                            <div class="error min-max text-red" *ngIf=" etrerappeleForm.get('heure').invalid && updateRequest">
                                Ce champ est obligatoire
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 text-center">
                    <button class="btn btn-large c-btnAjout" (click)="etreRappele()" [disabled]="updateRequest">
                  <i class="fa fa-pencil" *ngIf="!updateRequest"></i>
                  <i class="fa fa-spinner fa-pulse" *ngIf="updateRequest"></i>
                  Valider
                </button>
                </div>
            </div>

        </div>
    </form>
</ng-template>


<!-- Modal pour étre last-->
<ng-template #etreRappeller let-modal>
    <form [formGroup]="rappellerForm">
        <div class="card card2 c-card">
            <div class="row no-margin">
                <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 c-headModal">
                    <div class="row no-margin">
                        <div class="col-10 p-0">
                            <h6 class="text-left text-white c-cardTitle">Me faire rappeler</h6>
                        </div>
                        <div class="col-lg-2 text-right1">
                            <a aria-label="Close" (click)="modal.dismiss('close')" class="text-right"><i
                      class="fa fa-times text-white times-ass c-times-ass"></i></a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 mt-3">
                    <div class="row">

                        <div class="col-lg-6 col-md-12 col-xs-12 col-sm-12">
                            <div class="form" ngbPopover="Nom" triggers="mouseenter:mouseleave">
                                <i class="fa fa-user form__icon"></i>
                                <div class="form__separator">
                                </div>
                                <input type="text" id="emai" class="form__input" autocomplete="off" placeholder=" " formControlName="nom" />
                                <label for="emai" class="form__label">Nom<span
                                        class="text-red"> *</span></label>
                            </div>
                            <div class="error  text-red" *ngIf="invalid && rappellerForm.get('nom').invalid">
                                Ce champ est obligatoire
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12 col-xs-12 col-sm-12">
                            <div class="form" ngbPopover="Prénom" triggers="mouseenter:mouseleave">
                                <i class="fa fa-user form__icon"></i>
                                <div class="form__separator">
                                </div>
                                <input type="text" id="prenom" class="form__input" autocomplete="off" placeholder=" " formControlName="prenom" />
                                <label for="prenom" class="form__label">Prénom<span
                                        class="text-red"> *</span></label>
                            </div>
                            <div class="error  text-red" *ngIf="invalid && rappellerForm.get('prenom').invalid">
                                Ce champ est obligatoire
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12 col-xs-12 col-sm-12">
                            <div class="form" ngbPopover="Email" triggers="mouseenter:mouseleave">
                                <i class="fa fa-envelope form__icon"></i>
                                <div class="form__separator">
                                </div>
                                <input type="text" id="emai" class="form__input" autocomplete="off" placeholder=" " formControlName="email" />
                                <label for="emai" class="form__label">Email<span
                                        class="text-red"> *</span></label>
                            </div>
                            <div class="error  text-red" *ngIf="invalid && rappellerForm.get('email').invalid">
                                Ce champ est obligatoire
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12 col-xs-12 col-sm-12">
                            <div class="form" ngbPopover="Téléphone" triggers="mouseenter:mouseleave">
                                <i class="fa fa-phone form__icon"></i>
                                <div class="form__separator">
                                </div>
                                <input type="text" id="telephone" class="form__input" autocomplete="off" placeholder="Téléphone" formControlName="telephone" />
                                <label for="telephone" class="form__label">Téléphone<span
                                        class="text-red"> *</span></label>
                            </div>
                            <div class="error  text-red" *ngIf="invalid && rappellerForm.get('telephone').invalid">
                                Ce champ est obligatoire
                            </div>
                        </div>


                        <div class="col-lg-6 col-md-12 col-xs-12 col-sm-12">
                            <div class="form" placement="top" ngbPopover="Disponibilité" triggers="mouseenter:mouseleave">
                                <i class="fa fa-car form__icon"></i>
                                <div class="form__separator">
                                </div>
                                <select id="cars" placeholder=" " class="form__select" name="disponibilite" formControlName="disponibilite" name="product" #disponibilite (change)="checkDisponiblite()">
                                    <option value="" disabled selected>Disponibilité</option>
                                    <option *ngFor="let dispo of disponibiteList" [value]="dispo.value">{{dispo?.name}}
                                    </option>
                                </select>
                                <label for="cars" class="form__label">Disponibilité<span class="text-red">
                                        *</span></label>
                            </div>
                            <div class="error min-max text-red" *ngIf="invalid && rappellerForm.get('disponibilite').invalid">
                                Ce champ est obligatoire
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12 col-xs-12 col-sm-12" *ngIf="rappellerForm.get('disponibilite').value =='Soir' || rappellerForm.get('disponibilite').value =='Matin'">
                            <div class="form" placement="top" ngbPopover="Quelle heure" triggers="mouseenter:mouseleave">
                                <i class="fa fa-car form__icon"></i>
                                <div class="form__separator">
                                </div>
                                <select id="cars" placeholder=" " class="form__select" name="heureDisponibilite" formControlName="heureDisponibilite" #heureDisponibilite>
                                    <option value="" disabled selected>Quelle heure</option>
                                    <option *ngFor="let heure of heureDisponibiliteListTemoin" [value]="heure.value">{{heure?.name}}
                                    </option>
                                </select>
                                <label for="cars" class="form__label">Quelle heure<span class="text-red">
                                        *</span></label>
                            </div>
                            <div class="error min-max text-red" *ngIf="invalid && rappellerForm.get('heureDisponibilite').invalid">
                                Ce champ est obligatoire
                            </div>
                        </div>
                    </div>
                </div>


                <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 text-center">
                    <button class="btn btn-large c-btnAjout" (click)="meRappeller()" [disabled]="sendingRequestRappel">
                  <i class="fa fa-pencil" *ngIf="!sendingRequestRappel"></i>
                  <i class="fa fa-spinner fa-pulse" *ngIf="sendingRequestRappel"></i>
                  Valider
                </button>
                </div>
            </div>
        </div>
    </form>
</ng-template>

<!--end Modal pour étre rappelé last -->

<!--start inscription -->
<ng-template #contentResultsign let-modal>
    <div class="modal-body login">
        <form [formGroup]="inscriptionForm">
            <div class="container px-4 py-2 mx-auto">
                <div class="card card0">
                    <a class="close text-primary text-right loginclose" aria-label="Close" (click)="modal.dismiss('close')">
                        <span aria-hidden="true">&times;</span>
                    </a>
                    <div class="d-flex flex-lg-row flex-column-reverse">
                        <div class="card card1">
                            <div class="row justify-content-center my-auto">
                                <div class="col-md-10 col-10 mt-2">
                                    <!-- <div class="row justify-content-center px-3 mb-3"> <img id="logo" src="../../../../../assets/img/logo.png"> </div> -->
                                    <h6 class="msg-info text-center">Veuillez remplir ces champs svp!</h6>
                                    <div class="form-group"> <label class="form-control-label text-muted">Nom</label>
                                        <input type="text" id="nom" placeholder="" class="form-control" formControlName="nom">
                                        <div class="text-red ml-3" *ngIf="inscriptionForm.get('nom')?.errors?.required && (inscriptionForm?.get('nom')?.touched || inscriptionForm.get('nom')?.dirty)">
                                            Le champs nom est requis</div>
                                    </div>
                                    <div class="form-group"> <label class="form-control-label text-muted">Prénom
                                        </label> <input type="text" id="prenom" placeholder="" class="form-control" formControlName="prenom">
                                        <div class="text-red ml-3" *ngIf="inscriptionForm.get('prenom')?.errors?.required && (inscriptionForm.get('prenom')?.touched || inscriptionForm.get('prenom')?.dirty)">
                                            Le champs prénom est requis</div>
                                    </div>
                                    <div class="form-group"> <label class="form-control-label text-muted">Numéro
                                            téléphone</label> <input type="text" id="telephone" placeholder="" class="form-control" formControlName="telephone" prefix="+225 " [mask]="phoneMask">
                                        <div class="text-red ml-3" *ngIf="inscriptionForm.get('telephone')?.errors?.required && (inscriptionForm.get('telephone')?.touched || inscriptionForm.get('telephone')?.dirty)">
                                            Le champs téléphone est requis</div>
                                    </div>
                                    <div class="form-group"> <label class="form-control-label text-muted">Adresse
                                        mail</label> <input type="email" id="email" name="email" placeholder="" class="form-control" formControlName="email">
                                        <!-- <div class="text-red ml-3" *ngIf="inscriptionForm.get('email')?.errors?.required && (inscriptionForm.get('email')?.touched || inscriptionForm.get('email')?.dirty)">
                                        Le champs email est requis</div> -->
                                        <div class="text-red ml-3" *ngIf="inscriptionForm.get('email')?.errors?.pattern">Le champs email est incorrect
                                        </div>
                                    </div>
                                    <div class="row justify-content-center my-3 px-3"> <button class="btn-block btn-color" (click)="inscrireutil()" [disabled]="loaderVisible">S'inscrire</button> </div>
                                    <div class="row justify-content-center my-3 px-3" *ngIf="loaderVisible">
                                        <p class="text-center w-100"><i class=" fa fa-spinner fa-pulse text-primary"></i></p>
                                        <p class="text-center ">
                                            Inscription en cours
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="bottom text-center mb-1">
                                <p href="#" class="sm-text mx-auto mb-3">Vous avez déjà un compte?<button class="btn btn-white ml-2" (click)="souscrire()" [disabled]="loaderVisible">Connectez-vous!</button></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-template>

<!--end inscription  -->
<!--start etude comparative -->
<ng-template #etudeComparative let-modal>
    <div class="modal-body  bg-white  autodown" #etudeComparatif id="etudeComparative">
        <div class="row">
            <div class="imgLogo col-md-6 col-lg-5 col-sm-12 col-xs-12">
                <img [src]="logoImage" alt="" class="with_img_logo">
            </div>
            <div class="col-md-6 col-lg-7 col-sm-12 col-xs-12">
                <div class="etude_title">ETUDE COMPARATIVE DE PRIME AUTOMOBILE</div>
                <div class="c_container">
                    <span class="c-header">{{user?.infos?.firstName}} {{user?.infos?.lastName}}</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-lg-4 col-sm-12 col-xs-12">
                <div class="c_detail">
                    <span>Détails Cotation Automobile</span>
                </div>
            </div>
            <div class="col-md-6 col-lg-4 col-sm-12 col-xs-12 offset-lg-4">
                <div class="row">
                    <div class="col-lg-6">
                        <span class="nameE">Emission :</span>
                    </div>
                    <div class="col-lg-6">
                        {{simulationVehiculeForm.get('date_effet').value | date:'dd/MM/yyyy'}}
                    </div>
                    <div class="col-lg-6">
                        <span class="nameE">Echeance :</span>
                    </div>
                    <div class="col-lg-6">
                        {{simulationVehiculeForm.get('dateEcheance').value | date:'dd/MM/yyyy'}}
                    </div>
                </div>
            </div>
        </div>

        <div class="row table_1">
            <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th class="th_size text-center" style="width:10%">Immatriculation</th>
                            <th class="th_size text-center" style="width:8%">Genre</th>
                            <th class="th_size text-center" style="width:8%">Marque</th>
                            <th class="th_size text-center" style="width:8%">Puissance</th>
                            <th class="th_size text-center" style="width:11%">Valeur Neuve</th>
                            <th class="th_size text-center" style="width:11%">Valeur Venale</th>
                            <th class="th_size colorG text-center" *ngFor="let item of listAssureursComp">{{item?.nom | uppercase}}</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="td_size text-center">{{simulationVehiculeForm?.get('immatriculation')?.value}}</td>
                            <td class="td_size text-center">{{simulationVehiculeForm.get('modele')?.value}}</td>
                            <td class="td_size text-center">{{simulationVehiculeForm?.get('marque')?.value}}</td>
                            <td class="td_size text-center">{{simulationVehiculeForm?.get('puissance')?.value}} CV</td>
                            <td class="td_size text-center">{{simulationVehiculeForm?.get('valeurNeuf')?.value | number:'1.0-0':'fr'}}</td>
                            <td class="td_size text-center">{{simulationVehiculeForm.get('valeurVenal')?.value | number:'1.0-0':'fr'}}</td>
                            <td class="td_size text-center" *ngFor="let item of primeNetComp">{{item?.value | number:'1.0-0':'fr'}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row table_1">
            <div class="col-md-12 col-lg-4 col-sm-12 col-xs-12"></div>
            <div class="col-md-12 col-lg-8 col-sm-12 col-xs-12" style="padding-left: 15px;">
                <table class="table table-bordered">
                    <tr *ngIf="tcListComp.length != 0">
                        <td class="td_size text-center">Tierce Collision :</td>
                        <td class="td_size text-center" *ngFor="let tc of tcListComp">{{tc?.value | number:'1.0-0':'fr'}}</td>
                    </tr>
                    <tr *ngIf="bgListComp.length != 0">
                        <td class="td_size text-center">Bris de glace :</td>
                        <td class="td_size text-center" *ngFor="let br of bgListComp">{{br?.value | number:'1.0-0':'fr'}}</td>
                    </tr>
                    <tr *ngIf="avanceRecourComp.length != 0">
                        <td class="td_size text-center">Avance et recours :</td>
                        <td class="td_size text-center" *ngFor="let br of avanceRecourComp">{{br?.value | number:'1.0-0':'fr'}}</td>
                    </tr>
                    <tr *ngIf="defRecourComp.length != 0">
                        <td class="td_size text-center">Défense et recours :</td>
                        <td class="td_size text-center" *ngFor="let br of defRecourComp">{{br?.value | number:'1.0-0':'fr'}}</td>
                    </tr>
                    <tr *ngIf="inciListComp.length != 0">
                        <td class="td_size text-center">Incendie :</td>
                        <td class="td_size text-center" *ngFor="let inc of inciListComp">{{inc?.value | number:'1.0-0':'fr'}}</td>
                    </tr>
                    <tr *ngIf="volListComp.length != 0">
                        <td class="td_size text-center">Vol :</td>
                        <td class="td_size text-center" *ngFor="let vol of volListComp">{{vol?.value | number:'1.0-0':'fr'}}</td>
                    </tr>
                    <tr *ngIf="reducListComp.length != 0">
                        <td class="td_size text-center">Réduction :</td>
                        <td class="td_size text-center" *ngFor="let pr of reducListComp">{{pr?.value | number:'1.0-0':'fr'}}</td>
                    </tr>
                    <tr>
                        <td class="td_size text-center">Prime Nette :</td>
                        <td class="td_size text-center" *ngFor="let pr of primeNetComp">{{pr?.value | number:'1.0-0':'fr'}}</td>
                    </tr>
                    <tr>
                        <td class="td_size text-center">Coût de police :</td>
                        <td class="td_size text-center" *ngFor="let cout of coutPoliceComp">{{cout?.value |number:'1.0-0':'fr'}}</td>
                    </tr>
                    <tr>
                        <td class="td_size text-center">Taxe :</td>
                        <td class="td_size text-center" *ngFor="let ta of taxeComp">{{ta?.value |number:'1.0-0':'fr'}}</td>

                    </tr>
                    <tr>
                        <td class="td_size text-center">FGA :</td>
                        <td class="td_size text-center" *ngFor="let fga of fgaValComp">{{fga?.value |number:'1.0-0':'fr'}}</td>
                    </tr>
                    <tr>
                        <td class="td_size text-center fontBold">Prime TTC :</td>
                        <td class="td_size text-center fontBold" *ngFor="let ttc of primeTTCComp">{{ttc?.value |number:'1.0-0':'fr'}}</td>
                    </tr>
                </table>
            </div>
        </div>

        <br>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <span class="issu">A l'issue de l'appel d'offre que nous avons initié, suite à votre sollicitation les compagnies <span class="footerV">{{assurValue | uppercase}}</span> les compagnies présentes les memes garanties et assistance automobile
                </span>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <p class="issu"> <span class="conclu">Conclusion :</span> Nous recommandons,<span class="footerV">{{bestAssureur | uppercase}} </span>au regard de notre synthèse des primes, des tarif et de la qualité des prestations.</p>
            </div>
        </div>

    </div>
    <div>
        <button type="button" class="btn btn-warning btn-prev c-btn-prev  pull-left c-roundbtn" (click)="modal.close('close')">
            <!-- <i class="fa fa-chevron-left"></i>  -->
            Retour</button>
        <button type="button" class="btn btn-primary btn-tel c-roundbtn" (click)="captureEtude()">Télécharger
                <i class="fa fa-download"></i>
        </button>
    </div>
</ng-template>
<!-- end etude comparative -->


<swal #confirmSubscription2 title="Confirmation" text="Voulez-vous vraiment procéder à la souscription ?" icon="question" [reverseButtons]="true" [showCancelButton]="true" [focusCancel]="false" [confirmButtonText]="'OUI, BIEN SÛR'" [cancelButtonText]="'NON, ANNULER'"
    (confirm)="saveData()">
</swal>

<swal #confirmSubscription3 title="Confirmation" text="Voulez-vous vraiment procéder à la souscription ?" icon="question" [reverseButtons]="true" [showCancelButton]="true" [focusCancel]="false" [confirmButtonText]="'OUI, BIEN SÛR'" [cancelButtonText]="'NON, ANNULER'"
    (confirm)="saveSuiviCotationAuto()">
</swal>

<ng-template #mypop>
    1.Pour moi-même : mon nom est sur la carte à grise
    <br>2.Pour un tiers :pour une tierce personne
    <br>3.Pour le compte de :c'est ma voiture mais mon nom n'est pas sur la carte à grise
</ng-template>


<app-footer></app-footer>
